/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp. 2017
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([], function () {
	'use strict';

	/**
  * Create a Deferred from a Promise class
  * The reason this function is in common-core is because this is used in client and serveside JS
  * Instantiates the class and uses the promise instance and resolve/reject methods to create a deferred object.
  * @return {[type]}         [description]
  */

	return function () {
		var resolve = void 0,
		    reject = void 0;
		var promise = new Promise(function () {
			resolve = arguments[0];
			reject = arguments[1];
		});
		return { resolve: resolve, reject: reject, promise: promise };
	};
});
//# sourceMappingURL=Deferred.js.map



// WEBPACK FOOTER //
// ./src/js/lib/@waca/core-client/js/core-client/utils/Deferred.js